import React, { lazy, Suspense} from "react"

const Add = lazy(() => import("./icons/Add"))
const Adjustments = lazy(() => import("./icons/Adjustments"))
const Bell = lazy(() => import("./icons/Bell"))
const BellRinging = lazy(() => import("./icons/BellRinging"))
const BullHorn = lazy(() => import("./icons/BullHorn"))
const Cancel = lazy(() => import("./icons/Cancel"))
const Check = lazy(() => import("./icons/Check"))
const CheckCircle = lazy(() => import("./icons/CheckCircle"))
const ChevronDoubleLeft = lazy(() => import("./icons/ChevronDoubleLeft"))
const ChevronDoubleRight = lazy(() => import("./icons/ChevronDoubleRight"))
const ChevronDown = lazy(() => import("./icons/ChevronDown"))
const ChevronLeft = lazy(() => import("./icons/ChevronLeft"))
const ChevronRight = lazy(() => import("./icons/ChevronRight"))
const ChevronUp = lazy(() => import("./icons/ChevronUp"))
const Dislike = lazy(() => import("./icons/Dislike"))
const Dot = lazy(() => import("./icons/Dot"))
const Download = lazy(() => import("./icons/Download"))
const ExclamationTriangle = lazy(() => import("./icons/ExclamationTriangle"))
const ExternalLink = lazy(() => import("./icons/ExternalLink"))
const Facebook = lazy(() => import("./icons/Facebook"))
const FacebookSolidFill = lazy(() => import("./icons/FacebookSolidFill"))
const Heart = lazy(() => import("./icons/Heart"))
const HeartFilled = lazy(() => import("./icons/HeartFilled"))
const Info = lazy(() => import("./icons/Info"))
const Key = lazy(() => import("./icons/Key"))
const LifeBuoy = lazy(() => import("./icons/LifeBuoy"))
const LightBulbOn = lazy(() => import("./icons/LightBulbOn"))
const Like = lazy(() => import("./icons/Like"))
const LinkedIn = lazy(() => import("./icons/LinkedIn"))
const LinkedInSolidFill = lazy(() => import("./icons/LinkedInSolidFill"))
const Logout = lazy(() => import("./icons/Logout"))
const MagnifyingGlass = lazy(() => import("./icons/MagnifyingGlass"))
const Pencil = lazy(() => import("./icons/Pencil"))
const Plus = lazy(() => import("./icons/Plus"))
const Printer = lazy(() => import("./icons/Printer"))
const Star = lazy(() => import("./icons/Star"))
const StarFilled = lazy(() => import("./icons/StarFilled"))
const Trash = lazy(() => import("./icons/Trash"))
const Upload = lazy(() => import("./icons/Upload"))
const User = lazy(() => import("./icons/User"))
const UserCircle = lazy(() => import("./icons/UserCircle"))
const X = lazy(() => import("./icons/X"))
const YouTube = lazy(() => import("./icons/YouTube"))
const YouTubeSolidFill = lazy(() => import("./icons/YouTubeSolidFill"))

/* New UI Icons */
const AlarmClock = lazy(() => import("./icons/AlarmClock"))
const Archive = lazy(() => import("./icons/Archive"))
const BurgerMenu = lazy(() => import("./icons/BurgerMenu"))
const CheckMarkInSquare = lazy(() => import("./icons/CheckMarkInSquare"))
const Cog = lazy(() => import("./icons/Cog"))
const Collapse = lazy(() => import("./icons/Collapse"))
const Expand = lazy(() => import("./icons/Expand"))
const Handshake = lazy(() => import("./icons/Handshake"))
const Hierarchy = lazy(() => import("./icons/Hierarchy"))
const Home = lazy(() => import("./icons/Home"))
const Kebab = lazy(() => import("./icons/Kebab"))
const Layout = lazy(() => import("./icons/Layout"))
const Organisation = lazy(() => import("./icons/Organisation"))
const PersonCircle = lazy(() => import("./icons/PersonCircle"))
const PersonPlus = lazy(() => import("./icons/PersonPlus"))
const ProjectorBoard = lazy(() => import("./icons/ProjectorBoard"))
const Question = lazy(() => import("./icons/Question"))
const Tophat = lazy(() => import("./icons/Tophat"))
const TwoPeople = lazy(() => import("./icons/TwoPeople"))
const TwoPeopleCircle = lazy(() => import("./icons/TwoPeopleCircle"))
const Refresh = lazy(() => import("./icons/Refresh"))
const Exit = lazy(() => import("./icons/Exit"))
const Block = lazy(() => import("./icons/Block"))
const EqualSign = lazy(() => import("./icons/EqualSign"))

const iconNames = [
  "add",
  "adjustments",
  "bell",
  "bell-ringing",
  "bull-horn",
  "burger-menu",
  "cancel",
  "check",
  "check-circle",
  "chevron-double-left",
  "chevron-double-right",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "cog",
  "dislike",
  "dot",
  "download",
  "exclamation-triangle",
  "external-link",
  "facebook",
  "facebook-solid-fill",
  "heart",
  "heart-filled",
  "info",
  "key",
  "life-buoy",
  "light-bulb-on",
  "like",
  "linkedin",
  "linkedin-solid-fill",
  "logout",
  "magnifying-glass",
  "pencil",
  "plus",
  "printer",
  "star",
  "star-filled",
  "trash",
  "upload",
  "user",
  "user-circle",
  "x",
  "youtube",
  "youtube-solid-fill",

  "alarm-clock",
  "archive",
  "burger-menu",
  "check-mark-in-square",
  "cog",
  "collapse",
  "expand",
  "handshake",
  "hierarchy",
  "home",
  "kebab",
  "layout",
  "organisation",
  "person-circle",
  "person-plus",
  "projector-board",
  "question",
  "tophat",
  "two-people-circle",
  "two-people",
  "refresh",
  "exit",
  "block",
  'equal-sign'
]

// eslint-disable-next-line complexity
const iconForName = (name: string) => {
  switch (name) {
    case "add": return <Add />
    case "adjustments": return <Adjustments/>
    case "bell": return <Bell/>
    case "bell-ringing": return <BellRinging/>
    case "bull-horn": return <BullHorn/>
    case "cancel": return <Cancel/>
    case "check": return <Check/>
    case "check-circle": return <CheckCircle/>
    case "chevron-double-left": return <ChevronDoubleLeft/>
    case "chevron-double-right": return <ChevronDoubleRight/>
    case "chevron-down": return <ChevronDown/>
    case "chevron-left": return <ChevronLeft/>
    case "chevron-right": return <ChevronRight/>
    case "chevron-up": return <ChevronUp/>
    case "dislike": return <Dislike/>
    case "dot": return <Dot/>
    case "download": return <Download/>
    case "exclamation-triangle": return <ExclamationTriangle/>
    case "external-link": return <ExternalLink/>
    case "facebook": return <Facebook/>
    case "facebook-solid-fill": return <FacebookSolidFill/>
    case "heart": return <Heart/>
    case "heart-filled": return <HeartFilled/>
    case "info": return <Info/>
    case "key": return <Key/>
    case "life-buoy": return <LifeBuoy/>
    case "light-bulb-on": return <LightBulbOn/>
    case "like": return <Like/>
    case "linkedin": return <LinkedIn/>
    case "linkedin-solid-fill": return <LinkedInSolidFill/>
    case "logout": return <Logout/>
    case "magnifying-glass": return <MagnifyingGlass/>
    case "pencil": return <Pencil/>
    case "plus": return <Plus/>
    case "printer": return <Printer/>
    case "star": return <Star/>
    case "star-filled": return <StarFilled/>
    case "trash": return <Trash/>
    case "upload": return <Upload/>
    case "user": return <User/>
    case "user-circle": return <UserCircle/>
    case "x": return <X/>
    case "youtube": return <YouTube/>
    case "youtube-solid-fill": return <YouTubeSolidFill/>

    case "alarm-clock": return <AlarmClock />
    case "archive": return <Archive />
    case "burger-menu": return <BurgerMenu />
    case "check-mark-in-square": return <CheckMarkInSquare />
    case "cog": return <Cog />
    case "collapse": return <Collapse />
    case "expand": return <Expand />
    case "handshake": return <Handshake />
    case "hierarchy": return <Hierarchy />
    case "home": return <Home />
    case "kebab": return <Kebab />
    case "layout": return <Layout />
    case "organisation": return <Organisation />
    case "person-circle": return <PersonCircle />
    case "person-plus": return <PersonPlus />
    case "projector-board": return <ProjectorBoard />
    case "question": return <Question />
    case "tophat": return <Tophat />
    case "two-people-circle": return <TwoPeopleCircle />
    case "two-people": return <TwoPeople />
    case "refresh": return <Refresh />
    case "exit": return <Exit />
    case "block": return <Block />
    case "equal-sign": return <EqualSign />

    default:
      throw new Error(`No icon named ${name} registered in <Icon/>.`)
  }
}

export { iconNames, iconForName }
